var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "text-center mb-6" }, [
      _vm._v(_vm._s(_vm.$t("roomWizard.displaySettings")))
    ]),
    _c(
      "div",
      { staticClass: "text-center mb-4" },
      [
        _c("presentation-setup-selector", {
          on: { change: _vm.selectSetup },
          model: {
            value: _vm.presentationSetup,
            callback: function($$v) {
              _vm.presentationSetup = $$v
            },
            expression: "presentationSetup"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "d-flex justify-space-between my-8" },
      [
        !_vm.first
          ? _c("va-button", {
              staticClass: "mr-4",
              attrs: {
                color: "secondary",
                type: "outline",
                cta: _vm.$t("roomWizard.prev")
              },
              on: { click: _vm.onBack }
            })
          : _c("v-spacer"),
        _c("va-button", {
          attrs: { loading: _vm.loading, cta: _vm.$t("roomWizard.next") },
          on: { click: _vm.onFinish }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }